// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"InfoCard_infoCard__2ngWj","heading":"InfoCard_heading__1D1Xo","content":"InfoCard_content__1GovT"};